import { IconButton, Modal, Tooltip } from "@mui/material";
import { DataGrid, GridColumns, GridSelectionModel } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import React, { useEffect, useState, useContext } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import EstoqueBRF from "../../components/classes/EstoqueBRF";
import EstoqueBRFDataset from "../../components/data/EstoqueBRFDataset";
import SkuHelper from "../../helper/skuHelper";
import CentroDataset from "../../components/data/CentroDataset";
import Centro from "../../components/classes/CentroDistribuicao";
import CustomToolbarEstoqueBRF from "./customToolbar";
import { confirmAlert } from "react-confirm-alert";
import PageHelper from "../../helper/pageHelper";
import PropriedadeParceiroDataset from "../../components/data/PropriedadeParceiroDataSet";
import EstoqueParceiro from "../../components/classes/EstoqueParceiro";
import EstoqueParceiroDataset from "../../components/data/EstoqueParceiroDataset";
import { UserContext } from "../../App";
import DownloadCSVModal from "../../components/common/DownloadCSVModal/DownloadCSVModal";
import { Download } from "@mui/icons-material";
import Utils from "../../helper/utils";

import styles from './detail.module.css';

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function EstoqueEmbalagensGrid(props: any) {
  const { t } = useTranslation();

  const user: any = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(50);
  const [estoqueEmbalagens, setEstoqueEmbalagens] = useState<EstoqueBRF[]>([]);
  const [estoqueParceiro, setEstoqueParceiro] = useState<EstoqueParceiro[]>([]);
  const [centros, setCentros] = useState<Centro[]>([]);
  const [rows, setRows] = useState<Data>([]);
  const columns: GridColumns = createColumns();

  const [openDownloadCSVModal, setOpenDownloadCSVModal] =
    useState<boolean>(false);

  const estoqueBRFDataset: EstoqueBRFDataset = new EstoqueBRFDataset();
  const centroDataset: CentroDataset = new CentroDataset();
  const propriedadeParceiroDataset: PropriedadeParceiroDataset =
    new PropriedadeParceiroDataset();

  async function fetchData() {
    let centroIndustrializacao =
      await propriedadeParceiroDataset.getCentroIndustrializacao(
        props.parceiro.codigoFornecedorSAP.valueOf()
      );
    if (centroIndustrializacao == "N/A") {
      Mensagem(
        t("common.error"),
        t("pages.stockPartnerBrf.text.unableToFindIndustrializationCenter"),
        () => { } //prevent reload loop
      );
    } else {
      estoqueBRFDataset
        .getAll(centroIndustrializacao)
        .then((data) => {
          if (data) {
            setEstoqueEmbalagens(data);
            centroDataset.ListarAtivos().then((centros) => {
              setCentros(centros);
            });
          }
        })
        .catch(console.error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setLoading(false);
    fillTable(estoqueEmbalagens);
  }, [centros]);

  function Mensagem(titulo: string, mensagem: string, onClick = () => { PageHelper.refreshPage(); }): void {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.ok"),
          onClick: onClick,
        },
      ],
    });
  }

  function getCentroDescricao(idCentro: string): string {
    let nome: string = "";
    if (centros.length > 1) {
      const centroTemp: Centro | undefined = centros.find(
        (f) => f.centro === idCentro
      );
      if (centroTemp) {
        nome = centroTemp.nome as string;
      }
    }
    return nome;
  }

  function createColumns(): GridColumns {
    let cols: GridColumns = [
      {
        field: "id",
        headerName: t("common.id"),
        width: 80,
        align: "center",
        headerAlign: "center",
        renderHeader: (item) => {
          return <div>#</div>;
        },
      },
      {
        field: "material",
        headerName: t("common.material"),
        type: "string",
        width: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "materialDesc",
        headerName: t("common.materialDescription"),
        type: "string",
        width: 420,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "centro",
        headerName: t("common.center"),
        type: "string",
        width: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "centroDesc",
        headerName: t("common.centerDescription"),
        type: "string",
        width: 420,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "quantidade",
        headerName: t("common.sapQuantity"),
        type: "string",
        width: 150,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "quantidadeParceiro",
        headerName: t("common.partnerQuantity"),
        type: "string",
        width: 150,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "diferenca",
        headerName: t("common.distinction"),
        type: "string",
        width: 150,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      // {
      //   field: "opcoes",
      //   headerName: "Opções",
      //   type: "number",
      //   width: 150,
      //   editable: false,
      //   align: "center",
      //   headerAlign: "center",
      //   renderCell: (gridItem) => {
      //     return (
      //       <div>
      //         <Tooltip title="Editar">
      //           <IconButton onClick={() => handleUpdateEstoqueBRF(gridItem)}>
      //             <EditIcon />
      //           </IconButton>
      //         </Tooltip>
      //         <Tooltip title="Apagar">
      //           <IconButton onClick={() => handleDeleteEstoque(gridItem)}>
      //             <DeleteIcon />
      //           </IconButton>
      //         </Tooltip>
      //       </div>
      //     );
      //   },
      // },
    ];
    return cols;
  }

  function handleUpdateEstoqueBRF(item: any) {
    props.setSelectedEstoqueBRFupdater(item.row);
    props.handleUpdateEstoqueBRF();
  }

  function handleDeleteEstoque(item: any) {
    item.row.quantidade = item.row.quantidade.slice(
      0,
      item.row.unidadeMedida.length * -1
    );
    estoqueBRFDataset
      .remove(item.row)
      .then(() => {
        fetchData();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function fillTable(estoqueEmbalagens: EstoqueBRF[]) {
    let gridData: Data = [];
    estoqueEmbalagens.forEach((item: EstoqueBRF) => {
      let estoque = JSON.parse(EstoqueBRF.toJson(item));
      estoque.diferenca = estoque.quantidadeParceiro - estoque.quantidade;
      estoque.materialDesc = SkuHelper.getSKUName(parseInt(item.material));
      estoque.centroDesc = getCentroDescricao(item.centro);

      estoque.quantidade = Utils.maskNumberToSAPDecimalVisualization(
        parseFloat(estoque.quantidade).toFixed(3),
        item.unidadeMedida
      );
      estoque.quantidadeParceiro = Utils.maskNumberToSAPDecimalVisualization(
        parseFloat(estoque.quantidadeParceiro).toFixed(3),
        estoque.unidadeMedida
      );
      estoque.diferenca =
        (estoque.diferenca < 0 ? "-" : "") +
        Utils.maskNumberToSAPDecimalVisualization(
          parseFloat(estoque.diferenca).toFixed(3),
          item.unidadeMedida
        );

      gridData.push(estoque);
    });
    setRows(gridData);
  }

  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  function handleCloseDownloadCSVModal() {
    setOpenDownloadCSVModal(false);
  }

  return (
    <div className={styles.table}>
      <div className="containerToolbar">
        <Tooltip title={t("pages.stockPartnerBrf.text.csvDownload")}>
          <span>
            <IconButton
              onClick={handleClickOpenDownloadCSV}
              disabled={loading || user.isSuporte}
            >
              <Download />
            </IconButton>
          </span>
        </Tooltip>
      </div>
      <div className={`divFlow ${styles.table}`}>
        <div className={styles.table}>
          <DataGrid
            loading={loading}
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[50, 100, 250, 500]}
          />
        </div>

        <Modal
          open={openDownloadCSVModal}
          onClose={handleCloseDownloadCSVModal}
          sx={{
            display: "flex",
            "justify-content": "center",
            "align-items": "center",
          }}
        >
          <DownloadCSVModal
            handleClose={handleCloseDownloadCSVModal}
            rows={rows}
            columns={columns}
            name={t("pages.stockPartnerBrf.text.brfPartner")}
          />
        </Modal>
      </div>
    </div>
  );
}
